import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { API_BASE_URL } from "../../../config";
import {
  FaCheckCircle,
  FaClock,
  FaCalendarAlt,
  FaDollarSign,
  FaDoorOpen,
  FaCar,
  FaDog,
  FaBath,
  FaToilet,
  FaStar,
  FaBed,
} from "react-icons/fa";


/* ----------------- small helpers ----------------- */


function TaskRow({ label, active }) {
  return (
    <label style={taskRow}>
      <input type="checkbox" checked={!!active} readOnly />
      <span style={{ textTransform: "capitalize" }}>{label}</span>
    </label>
  );
}

// The keys here MUST match the keys saved in `services` in the DB
const TASK_DEFINITIONS = [
  { key: "dusting", label: "dusting" },
  { key: "vacuuming", label: "vacuuming" },
  { key: "mopping", label: "mopping" },
  { key: "surfacesWiped", label: "surfaces wiped" },
  { key: "tidying", label: "tidying" },
  { key: "kitchenCleaning", label: "kitchen cleaning" },
  { key: "bathroomCleaning", label: "bathroom cleaning" },
  { key: "bedMaking", label: "bed making" },
  { key: "linenChanging", label: "linen changing" },
  { key: "washing", label: "washing" },
  { key: "ironing", label: "ironing" },
  { key: "pantryTidying", label: "pantry tidying" },
  { key: "loungeVacuum", label: "lounge vacuum" },
  { key: "cobwebRemoval", label: "cobweb removal" },
  { key: "lightSpotCleaning", label: "light spot cleaning" },
  { key: "dishwashing", label: "dishwashing" },
  { key: "organisation", label: "organisation" },
];

/* ----------------- main component ----------------- */

function CleaningDetails() {
  const { listingId } = useParams();
  const [listing, setListing] = useState(null);


  useEffect(() => {
  async function load() {
    try {
      const isPublicId = String(listingId).startsWith("CLN-");

      const url = isPublicId
        ? `${API_BASE_URL}/api/cleaning/listings/by-listing-id/${listingId}`
        : `${API_BASE_URL}/api/cleaning/listings/${listingId}`;

      const res = await fetch(url);
      const data = await res.json();

      setListing(data);
    } catch (err) {
      console.error("Failed to load cleaning listing:", err);
    }
  }

  load();
}, [listingId]);



  if (!listing) return <p>Loading...</p>;

  const getGoogleMapsLink = (suburb, postcode, state) => {
  const location = `${suburb || ""} ${postcode || ""} ${state || ""} Australia`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`;
};

const formattedDate =
  listing.createdAt || listing.created_at
    ? new Date(listing.createdAt || listing.created_at).toLocaleDateString("en-AU")
    : "—";


  const services = listing.services || {};

    // =========================
  // BUY CLEANING LISTING
  // =========================
  const handleBuyNow = async () => {
    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));

      if (!token || !user) {
        alert("You must be logged in to buy this listing.");
        return;
      }

      const res = await fetch(
        `${API_BASE_URL}/api/cleaning/payment/buy`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
         body: JSON.stringify({
  listingId: listing.listingId,        // CLN-####
  buyerId: user.id,
  sellerId: listing.user_id,
  salePrice: listing.salePrice,        // ✅ THIS IS THE FIX
  email: user.email,
}),



        }
      );

      const data = await res.json();

      if (!res.ok || !data.url) {
        alert(data.error || "Failed to start checkout.");
        return;
      }

      window.location.href = data.url;
    } catch (err) {
      console.error("Buy error:", err);
      alert("Failed to buy listing.");
    }
  };


  return (
    <div style={container}>
      {/* HERO IMAGE (same idea as mowing) */}
      <img src="/images/cleaning.jpg" alt="Cleaning" style={hero} />

      <div style={{ padding: "25px" }}>
        <h2>
          Cleaning Client – {listing.listingId}
        </h2>
       <a
  href={getGoogleMapsLink(
    listing.suburb,
    listing.postcode,
    listing.state
  )}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    color: "#555",
    marginTop: 4,
    display: "inline-block",
    textDecoration: "none",
  }}
>
  <span
    style={{
      display: "inline-block",
      transition: "transform 0.2s ease",
      color: "#2e7d32",
      cursor: "pointer",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.25)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
    }}
  >
    📍
  </span>{" "}
  {listing.suburb}, {listing.state} {listing.postcode}
</a>
        <hr style={{ margin: "16px 0" }} />

        {/* HOME & AREAS */}
     <Section title="🏠 Home & Areas" color="#1e88e5">
  <Info icon={<FaBed />} label="Bedrooms Cleaned" value={listing.bedroomsCleaned} isText />
  <Info icon={<FaBath />} label="Bathrooms Cleaned" value={listing.bathroomsCleaned} isText />
  <Info icon={<FaToilet />} label="Toilets Cleaned" value={listing.toiletsCleaned} isText />
</Section>

        {/* SERVICE SCHEDULE */}
<Section title="📅 Service Schedule" color="#43a047">
  <Info
    icon={<FaClock />}
    label="Cleaning Time"
    value={
      listing.cleaningTime !== null && listing.cleaningTime !== undefined && listing.cleaningTime !== ""
        ? `${listing.cleaningTime} hr`
        : "—"
    }
    isText
  />
  <Info icon={<FaCalendarAlt />} label="Frequency" value={listing.frequency} isText />
  <Info
    icon={<FaStar />}
    label="Preferred Day/Time"
    value={`${listing.serviceDay || "—"} / ${listing.serviceTime || "—"}`}
    isText
  />
</Section>
        {/* ACCESS REQUIREMENTS */}
   <Section title="🚪 Access Requirements" color="#6d4c41">
  <Info icon={<FaDoorOpen />} label="Access Type" value={listing.accessType} isText />
  <Info icon={<FaDog />} label="Pets at Home" value={listing.petsAtHome} />
  <Info icon={<FaCar />} label="Street Parking" value={listing.streetParking} />
  <Info icon={<FaDoorOpen />} label="Alarm Code Required" value={listing.alarmCodeRequired} />
</Section>

     {/* ROUTINE CLEANING TASKS */}
<Section title="🧼 Routine Cleaning Tasks" color="#8e24aa">
  <div style={{ gridColumn: "1 / -1" }}>
    <div style={tasksGrid}>
      {TASK_DEFINITIONS
        .filter(
          (task) =>
            services[task.key] === true ||
            services[task.key] === 1 ||
            services[task.key] === "1" ||
            services[task.key] === "true"
        )
        .map((task) => (
          <p key={task.key} style={{ margin: "4px 0" }}>
            ✔ {task.label}
          </p>
        ))}
    </div>
  </div>
</Section>

        {/* CLIENT HISTORY */}
<Section title="🕒 Client History" color="#8e24aa">
  <Info
    icon={<FaCalendarAlt />}
    label="Client History"
    value={
      listing.newClient
        ? "New client (under 6 months)"
        : listing.longTermClient
        ? "Long-term client (12+ months)"
        : "Established client (6–12 months)"
    }
    isText
  />
</Section>

    

        {/* PRICING */}
<Section title="💰 Pricing" color="#fb8c00">
  <Info
    icon={<FaDollarSign />}
    label="Average Job Price"
    value={
      listing.avgJobPrice !== null && listing.avgJobPrice !== undefined
        ? `$${Number(listing.avgJobPrice).toFixed(2)}`
        : "—"
    }
    isText
  />
  <Info
    icon={<FaDollarSign />}
    label="Sale Price"
    value={
      listing.salePrice !== null && listing.salePrice !== undefined
        ? `$${Number(listing.salePrice).toFixed(2)}`
        : "—"
    }
    isText
  />
</Section>

        {/* Listing Verification */}
<div className="listing-verification">
  <div>
    <FaCheckCircle /> Posted On: {formattedDate}
  </div>
  <div>
    <FaCheckCircle /> Seller confirmed this listing is genuine.
  </div>
</div>


        {/* BUY / STATUS */}
{["active", "live"].includes(listing.listing_status) && (
  <button
    onClick={handleBuyNow}
    style={{
      marginTop: "20px",
      padding: "14px",
      backgroundColor: "#2e7d32",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      fontWeight: "bold",
      cursor: "pointer",
      width: "100%",
      fontSize: "16px",
    }}
  >
    Buy This Cleaning Client
  </button>
)}

{listing.listing_status === "locked" && (
  <div
    style={{
      marginTop: "20px",
      padding: "16px",
      background: "#fff3e0",
      border: "1px solid #ff9800",
      borderRadius: "8px",
      textAlign: "center",
    }}
  >
    <h3 style={{ color: "#e65100", marginBottom: "8px" }}>
      Buy in Progress
    </h3>
    <p style={{ margin: 0 }}>
      Another buyer is currently completing this purchase.
      Please check back shortly.
    </p>
  </div>
)}

{listing.listing_status === "sold" && (
  <p style={{ color: "red", marginTop: "10px", fontWeight: "bold" }}>
    This listing has been sold.
  </p>
)}


        <div style={{ marginTop: "30px" }}>
          <Link to="/cleaning/listings" style={backBtn}>
            ← Back to Cleaning Listings
          </Link>
        </div>
      </div>
    </div>
  );
}

const Section = ({ title, color, children }) => (
  <section style={{ marginTop: "25px" }}>
    <h2 style={{ borderBottom: `2px solid ${color}`, paddingBottom: "5px" }}>
      {title}
    </h2>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "15px",
        marginTop: "10px",
      }}
    >
      {children}
    </div>
  </section>
);

const Info = ({ icon, label, value, isText = false }) => {
  let displayValue = value;

  if (!isText) {
    if (
      value === true ||
      value === 1 ||
      value === "1" ||
      value === "true" ||
      value === "yes" ||
      value === "Yes"
    ) {
      displayValue = "Yes";
    } else if (
      value === false ||
      value === 0 ||
      value === "0" ||
      value === "false" ||
      value === "no" ||
      value === "No"
    ) {
      displayValue = "No";
    }
  }

  if (displayValue === null || displayValue === undefined || displayValue === "") {
    displayValue = "—";
  }

  return (
    <div
      style={{
        background: "#f8f9fa",
        borderRadius: "12px",
        padding: "14px 16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        display: "flex",
        gap: "12px",
      }}
    >
      <div style={{ fontSize: "1.2rem", color: "#2e7d32" }}>
        {icon}
      </div>
      <div>
        <div style={{ fontWeight: 700 }}>{label}</div>
        <div style={{ color: "#555" }}>{displayValue}</div>
      </div>
    </div>
  );
};

/* ----------------- styles ----------------- */

const container = {
  maxWidth: "900px",
  margin: "40px auto",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
  overflow: "hidden",
};

const hero = {
  width: "100%",
  height: "260px",
  objectFit: "cover",
};

const sectionTitle = {
  borderBottom: "2px solid #a020f0", // purple like mowing
  paddingBottom: "6px",
  marginBottom: "10px",
};

const backBtn = {
  padding: "10px 16px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  borderRadius: "6px",
  textDecoration: "none",
};

const tasksGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: "4px 24px",
};

const taskRow = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "0.95rem",
};

/* ----------------- export ----------------- */

export default CleaningDetails;
